import API from './axios';

export interface DigitalGuide {
  _id: string;
  name: string;
  content: {
    en: {
      title: string;
      subtitle: string;
      description: string;
      transformationSteps: string;
      transformationStepsSubtitle: string;
      digitalTransformationBenefits: string;
      digitalTransformationBenefitsSubtitle: string;
      steps: Array<{
        title: string;
        description: string;
        icon: string;
      }>;
      benefits: string[];
    };
    ru: {
      title: string;
      subtitle: string;
      description: string;
      transformationSteps: string;
      transformationStepsSubtitle: string;
      digitalTransformationBenefits: string;
      digitalTransformationBenefitsSubtitle: string;
      steps: Array<{
        title: string;
        description: string;
        icon: string;
      }>;
      benefits: string[];
    };
  };
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateDigitalGuideDto {
  name?: string;
  content?: {
    en: {
      title: string;
      subtitle: string;
      description: string;
      transformationSteps: string;
      transformationStepsSubtitle: string;
      digitalTransformationBenefits: string;
      digitalTransformationBenefitsSubtitle: string;
      steps: Array<{
        title: string;
        description: string;
        icon: string;
      }>;
      benefits: string[];
    };
    ru: {
      title: string;
      subtitle: string;
      description: string;
      transformationSteps: string;
      transformationStepsSubtitle: string;
      digitalTransformationBenefits: string;
      digitalTransformationBenefitsSubtitle: string;
      steps: Array<{
        title: string;
        description: string;
        icon: string;
      }>;
      benefits: string[];
    };
  };
  isActive?: boolean;
}

export const digitalGuideApi = {
  // Get all digital guides
  getAll: async (): Promise<DigitalGuide[]> => {
    const response = await API.get('/digital-guide');
    return response.data;
  },

  // Get main digital guide
  getMain: async (): Promise<DigitalGuide> => {
    const response = await API.get('/digital-guide/main');
    return response.data;
  },

  // Get digital guide by ID
  getById: async (id: string): Promise<DigitalGuide> => {
    const response = await API.get(`/digital-guide/${id}`);
    return response.data;
  },

  // Update main digital guide
  updateMain: async (data: UpdateDigitalGuideDto): Promise<DigitalGuide> => {
    const response = await API.patch('/digital-guide/main', data);
    return response.data;
  },

  // Update digital guide by ID
  updateById: async (id: string, data: UpdateDigitalGuideDto): Promise<DigitalGuide> => {
    const response = await API.patch(`/digital-guide/${id}`, data);
    return response.data;
  },

  // Create new digital guide
  create: async (data: Partial<DigitalGuide>): Promise<DigitalGuide> => {
    const response = await API.post('/digital-guide', data);
    return response.data;
  },

  // Delete digital guide by ID
  deleteById: async (id: string): Promise<void> => {
    await API.delete(`/digital-guide/${id}`);
  },

  // Initialize main digital guide
  initialize: async (): Promise<DigitalGuide> => {
    const response = await API.post('/digital-guide/initialize');
    return response.data;
  },
}; 